/* unplugin-vue-components disabled */import { render } from "./ImageUploadComponent.vue?vue&type=template&id=30330714&scoped=true"
import script from "./ImageUploadComponent.vue?vue&type=script&lang=js"
export * from "./ImageUploadComponent.vue?vue&type=script&lang=js"

import "./ImageUploadComponent.vue?vue&type=style&index=0&id=30330714&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30330714"]])

export default __exports__